export const CALLABLE_EMAIL_LIST_BREWERY_ACTIVITY_EMAILS =
  'callableEmailListActivityEmails-listEmails';
export const CALLABLE_EMAIL_PREVIEW_BREWERY_ACTIVITY_EMAIL =
  'callableEmailPreviewActivityEmail-preview';
export const CALLABLE_EMAIL_SEND_BREWERY_ACTIVITY_EMAIL =
  'callableEmailSendActivityEmail-send';
export const CALLABLE_EMAIL_PREPARE_BREWERY_ACTIVITY_EMAILS =
  'callableEmailPrepareActivityEmails-prepare';
